module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'brandMenuTable',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回菜單建置\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#blackModal"
    },
    domProps: {
      "textContent": _vm._s('黑名單設定')
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyLogsView'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    domProps: {
      "textContent": _vm._s('操作歷程')
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.setting.blacklist) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("白名單")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.whitelist)
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w-xs"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "w-sm"
  }, [_vm._v("黑名單")]), _vm._v(" "), _c('td', {
    staticClass: "w-auto",
    domProps: {
      "textContent": _vm._s(_vm.blacklist)
    }
  })])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.black.option
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('div', [_c('div', {
          staticClass: "mb-2"
        }, [_vm._v("請選擇要新增或編輯至黑名單的門市，可複選")]), _vm._v(" "), _c('multiselect', {
          attrs: {
            "tag-placeholder": "請輸入或選擇門市",
            "placeholder": "請輸入或選擇門市",
            "label": "name",
            "track-by": "id",
            "options": _vm.setting.whitelist,
            "multiple": true
          },
          model: {
            value: (_vm.black.temp),
            callback: function($$v) {
              _vm.$set(_vm.black, "temp", $$v)
            },
            expression: "black.temp"
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("白名單：名單內的門市當進行配料庫複製時「可」被覆寫，菜單上架時「可」被複寫")])]), _vm._v(" "), _c('div', {
    staticClass: "font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("設定")]), _vm._v(" "), _c('th', [_vm._v("門市")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf11ec48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/MenuSettingRuleStoreCopy.vue
// module id = 2544
// module chunks = 1